/* 
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved. 
* Distributed under the TruVideo proprietary license. 
*/
import React from 'react';
import PropTypes from 'prop-types';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Pagination = ({ currentPage, totalPages, onPageChange, loading }) => {
  if (totalPages <= 1) { return null; }

  return (
    <div className="flex items-center justify-between pt-5 border-t border-base-content/5 mt-4 pb-8">
      <p className="text-[14px] font-black text-base-content/20 uppercase tracking-widest">
        Page {currentPage} of {totalPages}
      </p>
      <div className="flex gap-2">
        <button
          disabled={currentPage === 1 || loading}
          onClick={() => onPageChange(currentPage - 1)}
          className="p-2 rounded-xl bg-base-100 border border-base-content/10 text-base-content/40 hover:text-primary hover:border-primary disabled:opacity-30 disabled:cursor-not-allowed transition-all"
          title="Previous Page"
        >
          <ChevronLeft size={18} />
        </button>
        <button
          disabled={currentPage >= totalPages || loading}
          onClick={() => onPageChange(currentPage + 1)}
          className="p-2 rounded-xl bg-base-100 border border-base-content/10 text-base-content/40 hover:text-primary hover:border-primary disabled:opacity-30 disabled:cursor-not-allowed transition-all"
          title="Next Page"
        >
          <ChevronRight size={18} />
        </button>
      </div>
    </div>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  onPageChange: PropTypes.func,
  loading: PropTypes.bool,
};

export default Pagination;
